import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonLabel, IonInput, useIonAlert, IonButtons, IonButton, IonItemGroup, IonItemDivider, IonDatetimeButton, IonCheckbox, IonTextarea, IonModal, IonDatetime, IonSegment, IonSegmentButton, IonIcon, IonLoading, IonFooter, IonRow, IonCol, IonTabButton, IonInfiniteScroll, IonInfiniteScrollContent, useIonViewWillEnter, IonList, ScrollDetail, IonSpinner } from '@ionic/react';
import { useEffect, useRef, useState } from 'react';
import './SmsViewer.css';
import { useHistory, useParams } from 'react-router';
import { getClient, addClient, removeClient, getClientByPhone } from '../firebase/clients';
import { getMoreSmses, registerSmsSnapshotListener, saveAndSendSms } from '../firebase/sms';
import dateFormat from 'dateformat';
import { callOutline, checkmarkCircleOutline, chevronBack, closeCircleOutline, ellipseSharp, helpCircle, helpCircleOutline, paperPlane, paperPlaneOutline } from 'ionicons/icons';
import { getCurrentUser } from '../firebase/firebase';
import { getUser } from '../firebase/users';
import { getUserNameByPhone } from './SmsPage';


const SmsViewer: React.FC = () => {

  const [presentAlert] = useIonAlert();
  const [first, setFirst] = useState(true);
  const [busy, setBusy] = useState(false);
  const [smsList, setSmsList] = useState<any[]>([]);
  const [smsListLoaded, setSmsListLoaded] = useState<any[]>([]);
  const [user, setUser] = useState('');
  const [message, setMessage] = useState('');
  const [sendingMessage, setSendingMessage] = useState(false);
  const params: any = useParams();
  const history = useHistory();
  const [isLoading, setLoading] = useState(false);
  const [scroll, setScroll] = useState<{ command: string | undefined, value: number }>({ command: undefined, value: 0 });

  const [isInfiniteDisabled, setInfiniteDisabled] = useState(false);




  useEffect(() => {
    if (content.current !== null) {
      content.current.scrollToBottom(0);
    }
    if (params.id !== undefined && params.id !== 0) {
      const unregister = registerSmsSnapshotListener(params.id, ((smsList: []) => {
        setSmsList(smsList);
        setScroll({ command: "bottom", value: 0 });
      }));
      setUser(getUserNameByPhone(params.id) + "");
      return () => {
        //console.log("unregister unregisterSmsSnapshotListener");
        unregister();
      };
    }
  }, []);


  function cancel() {
    history.goBack();
  }

  function sendMessage() {
    if (!sendingMessage && message.length > 0) {
      setSendingMessage(true);
      var data = { receiver: params.id, text: message, clientId: "0" };
      //console.log(data)
      saveAndSendSms(data);
      setMessage("");
      setSendingMessage(false);
    }
  }

  const content = useRef<HTMLIonContentElement>(null);



  function getUserInitials(userId: string) {
    if (userId !== undefined) {
      const u = getUser(userId);
      if (u !== undefined) {
        return u.initials;
      }
      return ''
    }
  }

  function showMessage(header: string, subHeader: string, message: string) {
    presentAlert({
      header: header,
      subHeader: subHeader,
      message: message,
      buttons: [
        {
          text: 'OK',
          role: 'confirm',
        },
      ],
    })
  }

  function getSmsIcon(sms: any) {
    if (sms.error !== undefined) {
      return <IonIcon icon={closeCircleOutline} onClick={(e) => { showMessage("Błąd wysyłania", "", sms.error) }}></IonIcon>;
    }
    if (sms.tmobileId !== undefined) {
      return <IonIcon icon={checkmarkCircleOutline}></IonIcon>;
    }
    return <IonIcon icon={helpCircleOutline}></IonIcon>;
  }





  if (content.current !== null) {
    if (scroll.command === undefined && scroll.value === 0) {
      content.current.scrollToBottom(0);
    } else {
      if (scroll.command === "top") {
        content.current.scrollToTop(0);
      } else if (scroll.command === "bottom") {
        content.current.scrollToBottom(0);
      } else if (scroll.command === "toPoint") {
        content.current.scrollToPoint(undefined, scroll.value, 0);
      } else if (scroll.command === "newData") {
        content.current?.getScrollElement().then((e) => {
          setScroll({ command: "toPoint", value: e.scrollHeight - scroll.value });
        })
      }
    }
  }


  async function handleScroll(ev: CustomEvent<ScrollDetail>) {

    if (isInfiniteDisabled) {
      return;
    }
    if (smsList.length < 20) {
      return;
    }
    if (isLoading) {
      return;
    }

    if (ev.detail.scrollTop < -5) {
      setLoading(true)
      setScroll({ command: "top", value: 0 });
      var smsListNew: any[] = await getMoreSmses();
      setTimeout(() => {
        if (smsListNew.length > 0) {
          content.current?.getScrollElement().then((e) => {
            setScroll({ command: "newData", value: e.scrollHeight });
            setSmsListLoaded([...smsListLoaded, ...smsListNew])
          })
        }
        if (smsListNew.length < 10) {
          setInfiniteDisabled(true);
        }
        setLoading(false)
      }, 500);
    }
  }


  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton color="medium" onClick={() => cancel()}>
              <IonIcon icon={chevronBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>{user} </IonTitle>
          <a slot="end" href={"tel:" + params.id.replace("0048", "")}><IonIcon icon={callOutline} /></a>
        </IonToolbar>
      </IonHeader>
      <IonLoading message="Proszę czekać..." duration={0} isOpen={busy} />

      <IonContent ref={content}
        scrollEvents={true}
        onIonScroll={handleScroll}

      >
        <div style={{ width: "100%", maxWidth:"650px", textAlign: "center" }} hidden={!isLoading}><IonSpinner/></div>

        <IonList>
          <div className="chat-window">
            {[...smsListLoaded, ...smsList].map((item: any) => {
              return <div className="break" key={item.id}>
                <div className={"chat-message " + (item.direct !== undefined && item.direct === "in" ? "left" : "right")}>
                  <div className="message-detail">
                    <div className='chat-message-header'>
                      <div className='chat-message-date'>{item.created !== undefined && item.created !== null ? dateFormat(item.created.toDate(), "yyyy-mm-dd HH:MM") : ""}</div>
                      <div className='chat-message-author'>{getUserInitials(item.userId)}</div>
                      <div className='chat-message-status' hidden={item.direct !== "out"}>{getSmsIcon(item)}</div>
                    </div>
                    {item.text.split("\n").map((s: string) => {
                      return <div key={s}>{s}</div>
                    })}

                  </div>
                </div>
              </div>
            })}
          </div>
        </IonList>

      </IonContent>
      <IonFooter style={{ maxWidth: "700px" }} >
        <IonToolbar>
          <div style={{ width: "100%" }}>
            <IonTextarea style={{ border: "solid 1px #488aff", padding: "3px", margin: "5px 5px 5px 5px", borderRadius: "10px" }} value={message} autoGrow={true} placeholder="wpisz wiadomość" onIonChange={(e) => { setMessage(e.detail.value + "") }}></IonTextarea>
          </div>
          <IonButtons slot="end">
            <IonButton onClick={(e) => sendMessage()}>
              <IonIcon style={sendingMessage || message.length == 0 ? { color: "#666666" } : { color: "#488aff" }} icon={paperPlane} />
            </IonButton>
          </IonButtons>
        </IonToolbar>


      </IonFooter>

    </IonPage >
  );
};

export default SmsViewer;
